<template src="./Home.html">
</template>

<script>
import axios from 'axios'

axios.defaults.headers.common['Pragma'] = 'no-cache';

export default {
  name: "home"
};
</script>

<style>
</style>
